import { useHistory, Redirect, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { GlobalBox } from "./GlobalBox";
import { OrderDetails } from "./OrderDetails";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import { MapComponent } from "views/Customers/MapComponent";
import { OrderComments } from "./OrderComments";
import { OrderEvidence } from "./OrderEvidence"
import { useSelector, useDispatch } from "react-redux";
import RegularButton from "components/CustomButtons/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Snackbar from "components/Snackbar/Snackbar";
import { useSearch } from "hooks/useSearch";
import { getPersistLocalStorage } from "../../helpers/localstorageTool";
import { ORDERS_SEARCH_PARAMS } from "../../helpers/agentList";
import { selectOrder, getOrderEta, getOrders } from "../../redux/actions/orders/ordersActions";
import { getSchedules } from "../../redux/actions/customers/customersAction";
import { getCoupons } from "../../redux/actions/coupons/couponsActions";

const url = "/admin/seguimiento_pedidos";

export const OrderSettings = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { order, orders, orderDetails } = useSelector(({ orders }) => orders);
  const { isOpen, color, message } = useSelector(({ search }) => search);
  const { clearSnackbar } = useSearch();
  const [map, setMap] = useState(null);
  const [isRehydrating, setIsRehydrating] = useState(!order?.id);
  const hist = useHistory();
  const handleNav = () => {
    hist.push(url);
  };

  // Rehidratar desde localStorage si el estado se perdió (ej: refresh - F5)
  useEffect(() => {
    if (!order?.id) {
      const searchParams = getPersistLocalStorage(ORDERS_SEARCH_PARAMS);
      if (searchParams) {
        dispatch(getOrders(searchParams));
      }
    }
  }, []);

  // Una vez que orders[] se llena, buscar la orden por id de la URL
  useEffect(() => {
    if (!order?.id && orders.length) {
      const foundOrder = orders.find((o) => o.id === id);
      if (foundOrder) {
        dispatch(selectOrder(foundOrder));
        dispatch(getCoupons(foundOrder.address?.id));
        dispatch(getSchedules(foundOrder.idStation, null, true));
        dispatch(getOrderEta([{ id: foundOrder.id }]));
      }
      setIsRehydrating(false);
    }
  }, [orders]);

  useEffect(() => {
    if (order?.id) {
      setMap(
        <MapComponent
          switchCss
          blockSearch
          type={order?.type}
          location={{
            latitude: order?.address?.latitude,
            longitude: order?.address?.longitude,
          }}
        />
      );
    }
  }, [order?.id]);

  // No mostrar nada mientras se rehidrata
  if (isRehydrating) return null;

  // Si después de rehidratar no hay orden, redirigir a la vista de seguimiento de pedidos
  if (!order?.id) {
    return <Redirect to={{ pathname: url, state: { fromOrderSettings: true } }} />;
  }

  return (
    <>
      <GlobalBox
        icon={<ConfirmationNumberIcon />}
        controls={
          <>
            <RegularButton justIcon round color="info" onClick={handleNav}>
              <ArrowBackIcon style={{ margin: 0 }} />
            </RegularButton>
          </>
        }
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <OrderDetails navigation={handleNav} />
          </Grid>
          <Grid item xs={12} sm={5}>
            {map}
          </Grid>
          <Grid item xs={12} sm={3}>
            <OrderComments order={order} />
            <OrderEvidence evidences={orderDetails.images} serviceId={id} />
          </Grid>
        </Grid>
      </GlobalBox>
      <Snackbar
        place="tr"
        color={color}
        message={message}
        open={isOpen}
        closeNotification={clearSnackbar}
        close
      />
    </>
  );
};
